
import React from "react";
import { Helmet } from "react-helmet";
import "./VerifyAccount.css";


export const VerifyAccount = () => {
     return (
          <>
               <Helmet>
                    <title>Verify Email Account | Metropolis</title>
               </Helmet>
               <section className="verify-account ground-color-ashes">
                    <div className="mtp-container">
                         <div className="verify-account-wrap">
                              <p className="verify-account-title fw-600">Verify Your Email to Activate Your Account.</p>
                              <span className="verify-account-confirm-content fw-400">A confirmation email has been sent to adam@metropolis.tech</span>
                              <a href="/signupVerified" className="button-alpha ">Resend Activation Email</a>
                              
                         </div>
                    </div>
               </section>
          </>
     )
}